import { createStore } from 'vuex'

import coinService from '@emcd-shared/coin-service'
import auth from '@/packages/auth-service/store'

import toast from '@/app/store/toast'
import paymentLink from '@/app/store/paymentLink'
import paymentLinkHistory from '@/app/store/paymentLinkHistory'
import massPaymentsHistory from '@/app/store/massPaymentsHistory'

import apiKey from '@/app/store/apiKey'
import swapLinks from '@/app/store/swapLinks'
import ui from '@/app/store/ui.store'
import user from '@/app/store/user.store'
import wallets from '@/app/store/wallets.store'
import exchange from '@/app/store/exchange.store'
import withdraw from '@/app/store/withdraw.store'
import sendToEmail from '@/app/store/send-to-email.store'
import partnerSettings from '@/app/store/partnerSettings'
import massPayments from '@/app/store/massPayments'
import massPaymentsRecipients from '@/app/store/massPaymentsRecipients'
import detailMassPayments from '@/app/store/detailMassPayments'
import invoices from '@/app/store/invoices'
import app from '@/app/store/app'
import partner from '@/app/store/partner.store'
import account from '@/app/store/account'

export default createStore({
  modules: {
    auth,
    coinService,
    paymentLink,
    paymentLinkHistory,
    partnerSettings,
    apiKey,
    swapLinks,
    ui,
    user,
    wallets,
    exchange,
    withdraw,
    sendToEmail,
    toast,
    app,
    massPayments,
    detailMassPayments,
    massPaymentsHistory,
    massPaymentsRecipients,
    invoices,
    partner,
    account,
  },
})
